import { ReactNode } from "react";
import { C } from "./designTokens";

interface SectionProps {
  children: ReactNode;
  background?: string;
  padding?: string;
  maxWidth?: string;
  id?: string;
}

export default function Section({
  children,
  background = C.white,
  padding = "80px 24px",
  maxWidth = "1200px",
  id,
}: SectionProps) {
  return (
    <section
      id={id}
      style={{
        background,
        width: "100%",
        margin: 0,
        padding: 0,
      }}
    >
      <div
        style={{
          maxWidth,
          margin: "0 auto",
          padding: window.innerWidth < 768 ? "48px 20px" : padding,
          boxSizing: "border-box",
        }}
      >
        {children}
      </div>
    </section>
  );
}
